var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._v("\n  © Copyright Aatrium Sisustuskaubamaja "+_vm._s(_vm.currentYear)+" |\n  "),_c('a',{attrs:{"target":"_blank","href":"https://www.zaproo.ee/"}},[_vm._v("\n    Zaproo eCommerce\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }